<template>
  <div class="mt-12" :class="setAlign()">
    <h4
      class="font-headline font-semibold text-2xl md:text-3xl my-4 leading-normal"
      :class="'text-' + color"
    >
      {{ subtitle }}
    </h4>

    <h1
      v-if="align === 'left'"
      class="font-headline font-light inline-flex my-4 text-5xl w-full"
      :class="'text-' + color"
    >
      {{ title }}
    </h1>

    <h1
      v-if="align === 'right'"
      class="font-headline font-light justify-end inline-flex text-5xl my-4 w-full"
      :class="'text-' + color"
    >
      {{ title }}
    </h1>

    <!-- BUTTON -->
    <p class="leading-relaxed text-paragraph">{{ caption }}</p>
  </div>
</template>

<script>
export default {
  name: "RoHSectionHeadline",
  props: {
    color: {
      type: String,
      default: "h-orange",
    },
    align: {
      type: String,
      default: "left",
    },
    title: {
      type: String
    },
    subtitle: {
      type: String
    },
    caption: {
      type: String
    }
  },
  methods: {
    setAlign() {
      if (this.align === "right") {
        return "text-right ";
      } else {
        return "text-left ";
      }
    },
  },
};
</script>

<style scoped></style>
